const JezikActionTypes = {
    PROMIJENI_SRPSKI: 'PROMIJENI_SRPSKI',
    PROMIJENI_ENGLESKI: 'PROMIJENI_ENGLESKI'
};

export default JezikActionTypes;